// src/lib/router-search.ts — parseSearch / stringifySearch the frontend
// router is built with. Extracted from main.tsx so it can be unit-tested
// without booting React, the router, or the DOM.
//
// ponytail: TanStack Router's `defaultStringifySearch` re-serializes any
// string that round-trips through `JSON.parse` back with `JSON.stringify`.
// `JSON.parse("27093558000115")` succeeds (returns the number
// 27093558000115), so the framework wraps a 14-digit CNPJ in literal quotes
// — `cnpj=%2227093558000115%22` in the URL bar. Page state still parses
// cleanly because `parseSearch` also runs JSON.parse, but the user-visible
// URL is broken (bookmarks, share-links, server log scraping, etc.).
//
// Fix: pin the parser TanStack Router calls before re-stringifying to a
// throwing stub. The catch in `stringifySearchWith` then returns the raw
// string. Object/array values still go through the `JSON.stringify` branch
// (the `typeof val === "object"` test fires first), so structured search
// params keep working. `parseSearch` keeps `JSON.parse` for the legacy URLs
// already shipped with quoted strings — decoding those still strips the
// quotes on the way in.
//
// ponytail: don't reach for any of this from `*.bun.test.ts`/backend. The
// router is a frontend concern; the backend reads CNPJ as a server-side
// query param (`request.query.cnpj`) and never sees this stringification.
import { parseSearchWith, stringifySearchWith } from "@tanstack/react-router";

export const parseSearch = parseSearchWith(JSON.parse);

export const stringifySearch = stringifySearchWith(
  JSON.stringify,
  // ponytail: any string that lands here would be JSON-encoded by the
  // next line; throwing prevents the rewrap. Object/array values go
  // through a different branch above and are unaffected.
  () => {
    throw new Error("never parse plain strings in stringifySearch");
  },
);
